import React, { useEffect, useMemo, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form, FormControl, InputGroup, Spinner } from "react-bootstrap";
import { useConsultDoctor, useOfflineApptStore } from "./store";
import { isEmpty } from "lodash";
import { DC_OPTION, fourPlaceHolder, groupSlots, OFFLINE_STORE } from "modules/utilities/utility";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Doctor from "assets/svgs/doctor";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { v4 as uuidv4 } from "uuid";
import useStatsStore from "modules/engagement_report/engagement_stats/store";
import { Button, Tooltip } from 'antd';

function ConsultDoctorCanvas({ caseId, name, email, phone, slotBooking, tickeId, reason, ...props }) {
  const { bookedData, slotData, allSlotData, bookedLoading, postSlotLoading, allSlotLoading, isLoading, fetchOnboardingData, fetchDoctorSlotData, postDoctorSlotData, postSlotApiData, fetchSlotData } = useConsultDoctor();
  const [show, setShow] = useState(false);
  const [filterSlotData, setFilterSlotData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const [formData, setFormData] = useState({ first_name: name, email: email, phone_number: phone });
  const [clinicId, setClinincId] = useState(null);
  const [bookingFlag, setBookingFlag] = useState(null);
  const { setToaster } = useToast();
  const sessionId = uuidv4();
  const { users, fetchUserData } = useStatsStore();
  const { appointments, fetchAppointmentData, bookOfflineAppt, apptLoading, isBooking } = useOfflineApptStore();
  useEffect(() => { if (!slotBooking) { fetchUserData(); } }, [slotBooking]);


  useEffect(() => {
    if (props.button === "Offline-Booking") {
      fetchAppointmentData(caseId, clinicId);
    }
  }, [clinicId])

  const interventionDocList = useMemo(() => {
    return users?.filter((doctor) => (doctor?.user?.meta?.is_intervention_doctor)).
      map((doctor) => ({ label: doctor?.user?.first_name, value: doctor?.user_id }));
  }, [users]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedValue = name === "phone_number" ? "+91" + value : value;
    setFormData({ ...formData, [name]: updatedValue });
  };

  useEffect(() => {
    if (!isEmpty(bookedData) && doctor) { fetchDoctorSlotData(bookedData?.caseId, doctor, toast); }
  }, [bookedData]);

  useEffect(() => {
    if (slotBooking) {
      if (props.button == "Offline-Booking" && !isEmpty(appointments)) {
        const groupSlot = groupSlots(appointments);
        setFilterSlotData(groupSlot);
      } else if (!isEmpty(allSlotData)) {
        const groupSlot = groupSlots(allSlotData);
        setFilterSlotData(groupSlot);
      }
    } else {
      if (!isEmpty(slotData)) {
        const groupSlot = groupSlots(slotData);
        setFilterSlotData(groupSlot);
      } else {
        setFilterSlotData([]);
      }
    }
  }, [slotData, allSlotData, appointments]);

  const handleDate = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedDate(null);
    setFilterSlotData(null);
    setSelectedSlot(null);
    setBookingFlag(null);
    setClinincId(null);
  };
  const handleShow = () => {
    setShow(true);
    setFilterSlotData(null);
    if (slotBooking) {
      if (props.button === 'Slot-Book' || props.button === 'Slot-Booking') {
        fetchSlotData(caseId, sessionId, toast, false, true);
      } else if (props.button === "Offline-Booking") {
        return;
      } else {
        fetchSlotData(caseId, sessionId, toast, false, false);
      }
    }
  };
  const handleSubmit = (event) => {
    if (slotBooking) {
      return;
    }
    event.preventDefault();
    fetchOnboardingData({ ...formData, gender: "M" }, toast);
  };

  const handleDoctorSlot = (slot) => {
    setSelectedSlot(slot);
  };

  const handleBookSlot = () => {
    if (slotBooking) {
      let selectedSlotPayload = {
        case_id: caseId,
        slot_id: selectedSlot.id,
        slots: selectedSlot?.slots,
        order_related: false,
        is_rescheduling: true,
        session_id: sessionId,
        from_crm: true,
      };
      if (props.button === 'Pres-Book') {
        selectedSlotPayload = {
          ...selectedSlotPayload,
          pc_slot: true
        }
      }
      if (props.button === "Offline-Booking") {
        let offlinePayload = {
          case_id: caseId,
          slot_id: selectedSlot.id,
          slots: selectedSlot?.slots,
          slot_time: selectedSlot.slotTime,
          paid: false,
          session_id: "",
        };
        if (bookingFlag === 'doctor') {
          offlinePayload = {
            ...offlinePayload,
            paid: true,
            from_crm: true
          }
        }
        bookOfflineAppt(offlinePayload, clinicId);
      } else {
        postSlotApiData(selectedSlotPayload, setToaster, handleClose);
      }
    } else {
      const selectedSlotPayload = {
        from_crm: true,
        case_id: bookedData?.caseId,
        transaction_id: bookedData?.transactionId,
        consult_doctor_fees: "0",
        slot_time: selectedSlot?.slotTime,
        slots: selectedSlot?.slots,
      };
      postDoctorSlotData(selectedSlotPayload, toast, handleClose);
    }
  };

  const handleDoctorChange = (event) => {
    setDoctor(event.target.value);
  };

  const handleFifteenDaysSlot = () => {
    if (props.button === "Offline-Booking") {
      fetchAppointmentData(caseId, clinicId, true);
    } else {
      fetchSlotData(caseId, sessionId, toast, false, true, '&is_15_days_slot_required=true');
    }
  }

  const bookLoading = slotBooking ? (postSlotLoading || isBooking) : isLoading;

  return (
    <>
      <div
        variant="primary"
        onClick={handleShow}
        className="text-center w-100"
      >
        <Tooltip title={slotBooking ? 'Slot Booking' : "Book consult doctor"}>
          {slotBooking ? (<Button block className='' size='middle' type='primary'>{props.button}</Button>) : (
            <span className="border border-info rounded-5 py-2 w-100 bg-info cursor-pointer">
              <Doctor gender="F" />
            </span>
          )}
        </Tooltip>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement='end'
        {...props}
        style={{ width: "50%" }}
      >
        <Offcanvas.Header closeButton>
          <div className="fw-bolf text-center font-poppins fs-3">
            {props.button}
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <div className="text-center">
              <Form onSubmit={handleSubmit}>
                <InputGroup className="mb-3">
                  <InputGroup.Text
                    id="basic-addon1"
                    className=" fw-bold"
                    style={{ width: "8rem" }}
                  >
                    Name
                  </InputGroup.Text>
                  <FormControl
                    name="first_name"
                    placeholder="Customer Name"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon1"
                    defaultValue={name}
                    onChange={handleInputChange}
                    required
                  />
                </InputGroup>
                <InputGroup className="mb-3">
                  <InputGroup.Text
                    id="basic-addon2"
                    className=" fw-bold"
                    style={{ width: "8rem" }}
                  >
                    Email
                  </InputGroup.Text>
                  <FormControl
                    name="email"
                    placeholder="john@gmail.com"
                    aria-label="Recipient's email"
                    aria-describedby="basic-addon2"
                    onChange={handleInputChange}
                    required
                    // pattern="^\S+@\S+$"
                    defaultValue={email}
                  />
                </InputGroup>
                <InputGroup className="mb-3">
                  <InputGroup.Text
                    id="basic-addon3"
                    className=" fw-bold"
                    style={{ width: "8rem" }}
                  >
                    Phone
                  </InputGroup.Text>
                  <FormControl
                    name="phone_number"
                    placeholder="99 99 999 999"
                    aria-label="Recipient's phone"
                    aria-describedby="basic-addon3"
                    onChange={handleInputChange}
                    defaultValue={phone.replace("+91", "")}
                    required
                  // pattern="^\d{10}$"
                  />
                </InputGroup>
                {!slotBooking && (
                  <Form.Select
                    name="from_crm"
                    required
                    aria-label="Default select example"
                    onChange={handleDoctorChange}
                  >
                    <option value="">Please Select Doctor</option>
                    {interventionDocList?.map((doctor) => {
                      return (
                        <option value={doctor?.value}>{doctor?.label}</option>
                      );
                    })}
                  </Form.Select>
                )}
                {props.button === "Offline-Booking" && (
                  <Form.Select
                    name="booking_type"
                    required
                    aria-label="Default select example"
                    onChange={(event) => setBookingFlag(event.target.value)}
                  >
                    <option value="">Please Select Booking Type</option>
                    {DC_OPTION?.map((clinic) => {
                      return (
                        <option value={clinic?.value}>{clinic?.label}</option>
                      );
                    })}
                  </Form.Select>
                )}
                {props.button === "Offline-Booking" && bookingFlag && (
                  <Form.Select
                    name="clinin_id"
                    required
                    aria-label="Default select example"
                    className="mt-3"
                    onChange={(event) => setClinincId(event.target.value)}
                  >
                    <option value="">Please Select Clinic</option>
                    {Object.keys(OFFLINE_STORE)?.map((clinic_id) => {
                      return (
                        <option value={clinic_id}>{OFFLINE_STORE[clinic_id]}</option>
                      );
                    })}
                  </Form.Select>
                )}
                {!slotBooking && (
                  <Button type="submit" className="w-25 mt-4 py-2 text-center">
                    {bookedLoading ? (
                      <span className="d-flex flex-row gap-2 justify-content-center">
                        <Spinner animation="border" variant="light" />
                        <span>Submitting</span>
                      </span>
                    ) : (
                      <span> Submit</span>
                    )}
                  </Button>
                )}
              </Form>
            </div>
            {slotBooking ? ((allSlotLoading || apptLoading) ? fourPlaceHolder() : null) : null}
            <div className="d-flex justify-content-center mt-3">
              <Button
                className="w-25 mt-4 py-2 text-center mt-n2"
                onClick={handleFifteenDaysSlot}
              >
                Get 15 Days Slots
              </Button>
            </div>
            
            <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">
              {filterSlotData &&
                Object.keys(filterSlotData)?.map((slotDate) => {
                  return (
                    <div
                      className="cursor-pointer"
                      onClick={() => handleDate(slotDate)}
                    >
                      <CardDiv
                        title={
                          <div className={slotDate == selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                            {moment(slotDate).format("ddd DD")}
                          </div>
                        }
                        component={
                          <div className={slotDate == selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                            {slotDate}
                          </div>
                        }
                      />
                    </div>
                  );
                })}
            </div>
            <div
              className="d-flex gap-3 flex-wrap mt-5 scrollable-container"
              style={{ maxHeight: "50vh", overflowY: "scroll" }}
            >
              {selectedDate &&
                filterSlotData[selectedDate]?.map((timeSlot) => {
                  console.log("here changes", moment(timeSlot?.slotTime).hour() < 10 && props.button === "Offline-Booking", "and", moment(timeSlot?.slotTime).hour() , props.button === "Offline-Booking")
                  if (moment(timeSlot?.slotTime).hour() < 10 && props.button === "Offline-Booking") {
                    return null;
                  }
                  return (
                    <Button
                      style={{ width: "100px" }}
                      onClick={() => handleDoctorSlot(timeSlot)}
                      className={
                        timeSlot?.slots?.count === 0
                          ? " py-2 fs-1 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                          : selectedSlot?.slotTime == timeSlot?.slotTime
                            ? "py-2 fs-1 bg-success text-white rounded-5 cursor-pointer text-center"
                            : " py-2 fs-1 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                      }
                    >
                      {moment(timeSlot?.slotTime).format("hh:mm A")}
                    </Button>
                  );
                })}
            </div>
            {selectedSlot && (
              <Button
                className="mt-5 py-2 fs-1 w-100 "
                onClick={handleBookSlot}
              >
                {bookLoading ? (
                  <span className="d-flex flex-row gap-2 justify-content-center">
                    <Spinner animation="border" variant="primary" />
                    <span>Booking Call Now</span>
                  </span>
                ) : (
                  <span>Book Call Now</span>
                )}
              </Button>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}


export default ConsultDoctorCanvas;
